import { createContext } from "react";
const DownloadMultipageContext = createContext({});
export default DownloadMultipageContext;
